import { useAppearance } from '~/data/appearance';
import { useCompanyData } from '~/data/company/useCompanyData';
import {
  allPortalDataDispatchReduxFetches,
  portalMinimumDataDispatchReduxFetches,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData/useInitializeCommonReduxData';

export const usePortalViews = () => {
  const companyDataState = useCompanyData();

  const appearanceState = useAppearance();

  const {
    requiredStatus: { isInitializing, percentage },
  } = useInitializeCommonReduxData({
    required: portalMinimumDataDispatchReduxFetches,
    preload: allPortalDataDispatchReduxFetches,
  });

  const isLoading =
    (appearanceState.isEnabled && appearanceState.isLoading) ||
    (!companyDataState.hasData && companyDataState.isLoading);

  return {
    initializationPercentage: percentage,
    isInitializing,
    isLoading,
  };
};
